import React from "react";
import { useApp } from "context";
import { Grid, IconButton } from "@mui/material";
import { Custom } from "components";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CancelIcon from "@mui/icons-material/Cancel";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

type Props = {
  items: any;
  onReorder: any;
  onDelete: any;
};

export const ReorderList = (props: Props) => {
  const { t, theme, service } = useApp();

  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    props.onReorder(result.source.index, result.destination.index);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="vertical">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {props.items.map((item: any, index: number) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      userSelect: "none",
                      ...provided.draggableProps.style,
                      top: "auto !important",
                      left: "auto !important",
                      marginBottom: "1rem",
                    }}
                  >
                    <Custom.Box
                      //   style={{
                      //     backgroundColor: snapshot.isDragging
                      //       ? "#263B4A"
                      //       : "#456C86",
                      //   }}
                      variant={"filled"}
                      // sx={{ paddingLeft: "2rem" }}
                    >
                      <IconButton onClick={() => {}} sx={{ cursor: "unset" }}>
                        <DragIndicatorIcon />
                      </IconButton>

                      <div style={{ margin: "auto" }}>{item.name}</div>

                      <IconButton onClick={() => props.onDelete(item.id)}>
                        <CancelIcon />
                      </IconButton>
                    </Custom.Box>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
